import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import CategoriesSection from "@/components/CategoriesSection";
import PawnProcessSection from "@/components/PawnProcessSection";
import ArcherySection from "@/components/GunRangeSection";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import CityLandingPage from "@/components/CityLandingPage";
import LocationsIndex from "@/components/LocationsIndex";
import SitemapPage from "@/components/SitemapPage";
import PawnShopsNearMe from "@/components/PawnShopsNearMe";

function HomePage() {
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observerRef.current?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
    );

    const t = setTimeout(() => {
      document.querySelectorAll('.reveal-section').forEach((el) => {
        observerRef.current?.observe(el);
      });
    }, 100);

    return () => {
      clearTimeout(t);
      observerRef.current?.disconnect();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <div className="reveal-section">
          <CategoriesSection />
        </div>
        <div className="reveal-section">
          <PawnProcessSection />
        </div>
        <div className="reveal-section">
          <ArcherySection />
        </div>
        <div className="reveal-section">
          <AboutSection />
        </div>
        <div className="reveal-section">
          <ContactSection />
        </div>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background overflow-x-hidden">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/locations" element={<LocationsIndex />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/pawn-shops-near-me.html" element={<PawnShopsNearMe />} />
          <Route path="/:citySlug" element={<CityLandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
